import { Component, OnInit } from '@angular/core';
import { ActualiteService, ContextService } from '../../shared';

@Component({
  selector: 'app-actualite',
  templateUrl: './actualite.component.html',
  styleUrls: ['./actualite.component.scss']
})
export class ActualiteComponent implements OnInit {
  
  constructor(
    private actualiteService: ActualiteService,
     private contextService: ContextService
  ) { }

  actualites:Array<string> = [];
  loading: boolean = true;
  context: string;

  ngOnInit() {
    this.context = this.contextService.getContext();
  	this.actualiteService.getAllActualites()
      .subscribe(actualites => {
        this.actualites = actualites;
        this.loading = false;
    });

  }

}



// WEBPACK FOOTER //
// ./src/app/actualite/_list/actualite.component.ts